module.exports = __webpack_public_path__ + "static/Gantt-bfdd5407b00b3ee01fa5b89cede6411d.png";